import { detectLanguage } from './evaluationService';

// List of languages supported by Google's language detection service
// from: https://cloud.google.com/translate/docs/languages
export const googleSupportedLanguages = [
    { code: 'detect', name: 'Detect language' },
    { code: 'ab', name: 'Abkhaz' },
    { code: 'ace', name: 'Acehnese' },
    { code: 'ach', name: 'Acholi' },
    { code: 'af', name: 'Afrikaans' },
    { code: 'sq', name: 'Albanian' },
    { code: 'alz', name: 'Alur' },
    { code: 'am', name: 'Amharic' },
    { code: 'ar', name: 'Arabic' },
    { code: 'hy', name: 'Armenian' },
    { code: 'as', name: 'Assamese' },
    { code: 'awa', name: 'Awadhi' },
    { code: 'ay', name: 'Aymara' },
    { code: 'az', name: 'Azerbaijani' },
    { code: 'ban', name: 'Balinese' },
    { code: 'bm', name: 'Bambara' },
    { code: 'ba', name: 'Bashkir' },
    { code: 'eu', name: 'Basque' },
    { code: 'btx', name: 'Batak Karo' },
    { code: 'bts', name: 'Batak Simalungun' },
    { code: 'bbc', name: 'Batak Toba' },
    { code: 'be', name: 'Belarusian' },
    { code: 'bem', name: 'Bemba' },
    { code: 'bn', name: 'Bengali' },
    { code: 'bew', name: 'Betawi' },
    { code: 'bho', name: 'Bhojpuri' },
    { code: 'bik', name: 'Bikol' },
    { code: 'bs', name: 'Bosnian' },
    { code: 'br', name: 'Breton' },
    { code: 'bg', name: 'Bulgarian' },
    { code: 'bua', name: 'Buryat' },
    { code: 'yue', name: 'Cantonese' },
    { code: 'ca', name: 'Catalan' },
    { code: 'ceb', name: 'Cebuano' },
    { code: 'ny', name: 'Chichewa (Nyanja)' },
    { code: 'zh', name: 'Chinese (Simplified)' },
    { code: 'zh-TW', name: 'Chinese (Traditional)' },
    { code: 'cv', name: 'Chuvash' },
    { code: 'co', name: 'Corsican' },
    { code: 'crh', name: 'Crimean Tatar' },
    { code: 'hr', name: 'Croatian' },
    { code: 'cs', name: 'Czech' },
    { code: 'da', name: 'Danish' },
    { code: 'din', name: 'Dinka' },
    { code: 'dv', name: 'Divehi' },
    { code: 'doi', name: 'Dogri' },
    { code: 'dov', name: 'Dombe' },
    { code: 'nl', name: 'Dutch' },
    { code: 'dz', name: 'Dzongkha' },
    { code: 'en', name: 'English' },
    { code: 'eo', name: 'Esperanto' },
    { code: 'et', name: 'Estonian' },
    { code: 'ee', name: 'Ewe' },
    { code: 'fj', name: 'Fijian' },
    { code: 'fi', name: 'Finnish' },
    { code: 'fr', name: 'French' },
    { code: 'fr-FR', name: 'French (French)' },
    { code: 'fr-CA', name: 'French (Canadian)' },
    { code: 'fy', name: 'Frisian' },
    { code: 'ff', name: 'Fulfulde' },
    { code: 'gaa', name: 'Ga' },
    { code: 'gl', name: 'Galician' },
    { code: 'lg', name: 'Ganda (Luganda)' },
    { code: 'ka', name: 'Georgian' },
    { code: 'de', name: 'German' },
    { code: 'el', name: 'Greek' },
    { code: 'gn', name: 'Guarani' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'ht', name: 'Haitian Creole' },
    { code: 'cnh', name: 'Hakha Chin' },
    { code: 'ha', name: 'Hausa' },
    { code: 'haw', name: 'Hawaiian' },
    { code: 'he', name: 'Hebrew' },
    { code: 'hil', name: 'Hiligaynon' },
    { code: 'hi', name: 'Hindi' },
    { code: 'hmn', name: 'Hmong' },
    { code: 'hu', name: 'Hungarian' },
    { code: 'hrx', name: 'Hunsrik' },
    { code: 'is', name: 'Icelandic' },
    { code: 'ig', name: 'Igbo' },
    { code: 'ilo', name: 'Iloko' },
    { code: 'id', name: 'Indonesian' },
    { code: 'ga', name: 'Irish' },
    { code: 'it', name: 'Italian' },
    { code: 'ja', name: 'Japanese' },
    { code: 'jv', name: 'Javanese' },
    { code: 'kn', name: 'Kannada' },
    { code: 'pam', name: 'Kapampangan' },
    { code: 'kk', name: 'Kazakh' },
    { code: 'km', name: 'Khmer' },
    { code: 'cgg', name: 'Kiga' },
    { code: 'rw', name: 'Kinyarwanda' },
    { code: 'ktu', name: 'Kituba' },
    { code: 'gom', name: 'Konkani' },
    { code: 'ko', name: 'Korean' },
    { code: 'kri', name: 'Krio' },
    { code: 'ku', name: 'Kurdish (Kurmanji)' },
    { code: 'ckb', name: 'Kurdish (Sorani)' },
    { code: 'ky', name: 'Kyrgyz' },
    { code: 'lo', name: 'Lao' },
    { code: 'ltg', name: 'Latgalian' },
    { code: 'la', name: 'Latin' },
    { code: 'lv', name: 'Latvian' },
    { code: 'lij', name: 'Ligurian' },
    { code: 'li', name: 'Limburgan' },
    { code: 'ln', name: 'Lingala' },
    { code: 'lt', name: 'Lithuanian' },
    { code: 'lmo', name: 'Lombard' },
    { code: 'luo', name: 'Luo' },
    { code: 'lb', name: 'Luxembourgish' },
    { code: 'mk', name: 'Macedonian' },
    { code: 'mai', name: 'Maithili' },
    { code: 'mak', name: 'Makassar' },
    { code: 'mg', name: 'Malagasy' },
    { code: 'ms', name: 'Malay' },
    { code: 'ms-Arab', name: 'Malay (Jawi)' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'mt', name: 'Maltese' },
    { code: 'mi', name: 'Maori' },
    { code: 'mr', name: 'Marathi' },
    { code: 'chm', name: 'Meadow Mari' },
    { code: 'mni-Mtei', name: 'Meiteilon (Manipuri)' },
    { code: 'min', name: 'Minang' },
    { code: 'lus', name: 'Mizo' },
    { code: 'mn', name: 'Mongolian' },
    { code: 'my', name: 'Myanmar (Burmese)' },
    { code: 'nr', name: 'Ndebele (South)' },
    { code: 'new', name: 'Nepalbhasa (Newari)' },
    { code: 'ne', name: 'Nepali' },
    { code: 'nso', name: 'Northern Sotho (Sepedi)' },
    { code: 'no', name: 'Norwegian' },
    { code: 'nus', name: 'Nuer' },
    { code: 'oc', name: 'Occitan' },
    { code: 'or', name: 'Odia (Oriya)' },
    { code: 'om', name: 'Oromo' },
    { code: 'pag', name: 'Pangasinan' },
    { code: 'pap', name: 'Papiamento' },
    { code: 'ps', name: 'Pashto' },
    { code: 'fa', name: 'Persian' },
    { code: 'pl', name: 'Polish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'pt-PT', name: 'Portuguese (Portugal)' },
    { code: 'pt-BR', name: 'Portuguese (Brazil)' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'pa-Arab', name: 'Punjabi (Shahmukhi)' },
    { code: 'qu', name: 'Quechua' },
    { code: 'rom', name: 'Romani' },
    { code: 'ro', name: 'Romanian' },
    { code: 'rn', name: 'Rundi' },
    { code: 'ru', name: 'Russian' },
    { code: 'sm', name: 'Samoan' },
    { code: 'sg', name: 'Sango' },
    { code: 'sa', name: 'Sanskrit' },
    { code: 'gd', name: 'Scots Gaelic' },
    { code: 'sr', name: 'Serbian' },
    { code: 'st', name: 'Sesotho' },
    { code: 'crs', name: 'Seychellois Creole' },
    { code: 'shn', name: 'Shan' },
    { code: 'sn', name: 'Shona' },
    { code: 'scn', name: 'Sicilian' },
    { code: 'szl', name: 'Silesian' },
    { code: 'sd', name: 'Sindhi' },
    { code: 'si', name: 'Sinhala (Sinhalese)' },
    { code: 'sk', name: 'Slovak' },
    { code: 'sl', name: 'Slovenian' },
    { code: 'so', name: 'Somali' },
    { code: 'es', name: 'Spanish' },
    { code: 'su', name: 'Sundanese' },
    { code: 'sw', name: 'Swahili' },
    { code: 'ss', name: 'Swati' },
    { code: 'sv', name: 'Swedish' },
    { code: 'tl', name: 'Tagalog (Filipino)' },
    { code: 'tg', name: 'Tajik' },
    { code: 'ta', name: 'Tamil' },
    { code: 'tt', name: 'Tatar' },
    { code: 'te', name: 'Telugu' },
    { code: 'tet', name: 'Tetum' },
    { code: 'th', name: 'Thai' },
    { code: 'ti', name: 'Tigrinya' },
    { code: 'ts', name: 'Tsonga' },
    { code: 'tn', name: 'Tswana' },
    { code: 'tr', name: 'Turkish' },
    { code: 'tk', name: 'Turkmen' },
    { code: 'ak', name: 'Twi (Akan)' },
    { code: 'uk', name: 'Ukrainian' },
    { code: 'ur', name: 'Urdu' },
    { code: 'ug', name: 'Uyghur' },
    { code: 'uz', name: 'Uzbek' },
    { code: 'vi', name: 'Vietnamese' },
    { code: 'cy', name: 'Welsh' },
    { code: 'xh', name: 'Xhosa' },
    { code: 'yi', name: 'Yiddish' },
    { code: 'yo', name: 'Yoruba' },
    { code: 'yua', name: 'Yucatec Maya' },
    { code: 'zu', name: 'Zulu' }
];

const normalizeGoogleLanguageCode = (code) => {
    switch (code) {
        case 'fil': return 'tl';
        case 'zh-CN': return 'zh';
        case 'iw': return 'he'; // Modern Hebrew → legacy code (Google sometimes uses 'iw')
        case 'jw': return 'jv'; // Javanese (sometimes appears as 'jw' in Google legacy)
        case 'nb': return 'no';
        default: return code;
    }
};

export const detectLanguageFromText = async (text) => {
    if (!text || text.trim().length < 1) return null;
    try {
        const detected = await detectLanguage(text);
        if (detected) {
            const normalized = normalizeGoogleLanguageCode(detected.toLowerCase());
            const lang = googleSupportedLanguages.find(
                l => l.code.toLowerCase() === normalized
            );

            if (lang) {
                return lang;
            } else {
                return { code: normalized, name: normalized, hidden: true };
            }
        }
    } catch (error) {
        console.error('Language detection failed:', error);
    }
    return null;
}; 